import { c as _c } from "react/compiler-runtime";
import styles from "@website/ui/top-app-bar/top-app-bar.module.scss";
import { TopAppBarPropertiesType } from "@website/ui/top-app-bar/top-app-bar.types";
import { FC } from "react";
export const TopAppBar: FC<TopAppBarPropertiesType> = properties => {
  const $ = _c(8);
  const {
    StartAction,
    title,
    EndAction,
    fixed: t0,
    className,
    style
  } = properties;
  const fixed = t0 === undefined ? false : t0;
  const t1 = `${styles.container} ${className || ""} ${fixed ? styles.fix : ""}`;
  let t2;
  if ($[0] !== title) {
    t2 = <div className={styles.title}>{title}</div>;
    $[0] = title;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== EndAction || $[3] !== StartAction || $[4] !== style || $[5] !== t1 || $[6] !== t2) {
    t3 = <div className={t1} style={style}>{StartAction}{t2}{EndAction}</div>;
    $[2] = EndAction;
    $[3] = StartAction;
    $[4] = style;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};